module.exports = __webpack_public_path__ + "static/img/home_backgroundImg3.6d8768f5.png";